import React from 'react';
import '../template-file-css/document-file-template.css'; 


export const NWBH_NoticePrivacyPractices = ({
    itemsRef,
    showErrorFor, 
}) => {

    return (
        <form id='NWBH_NoticePrivacyPractices' className='file-pdf-document'>
            <div className='file-template'>


            <p className='w-750'><h3>Northwest Behavioral Health Services, Inc.</h3></p>
                <p className='w-750'><h3>Notice of Privacy Practices</h3></p>
                <p className='w-750'><h4>Northwest Behavioral Health Adult Services</h4></p>
                <p className='w-750'><h4>Northwest Behavioral Health Children Services</h4></p>
                <p className='w-750'><h4>Northwest Behavioral Health Housing Initiative</h4></p>

                <p className='w-750'>
                    <b>THIS NOTICE DESCRIBES HOW MEDICAL INFORMATION ABOUT YOU MAY BE USED AND
                        DISCLOSED AND HOW YOU CAN ACCESS SUCH INFORMATION. PLEASE REVIEW IT CAREFULLY.
                        THE NOTICE IS BASED ON THE HEALTH INSURANCE AND PORTABILITY ACT AND RELATED
                        FEDERAL REGULATIONS AND CERTAIN RULES OF THE STATE OF FLORIDA.</b>
                </p>


                <p className='w-750'>Effective date: February 1, 2019</p>

                <p className='w-750'>
                    Each time you receive care or treatment at Northwest Behavioral Health Services, Inc.(NWBHS), a record of
                    your visit is made. Typically, this record contains your symptoms, diagnoses, treatment information,
                    treatment plan, service plan, identifying information and billing-related information, as recorded by NWBHS
                    staff. This Notice is provided to inform you regarding (i) how Northwest Behavioral Health Services, Inc.
                    may use or disclose medical information about you, (ii) with whom medical information about you may be
                    shared, (iii) the safeguards NWBHS has in place to protect medical information about you and (iv) your
                    rights to access and amend medical information about you. For purposes of this Notice, "medical
                    information about you" includes sexually-transmissible disease-related information (including HIV and
                    AIDS), genetic information, alcohol and/or substance abuse information, mental health information and
                    other specially protected health information that may be subject to additional confidentiality protections
                    under applicable State and federal law.
                </p>

                <p className='w-750'>
                    NWBHS is required to maintain the privacy of medical information about you and abide by the terms of this
                    Notice (or the version currently in effect). NWBHS reserves the right to change this Notice in the future. Its
                    effective date is noted at the top of this page. NWBHS reserves the right to make the revised or changed
                    notice effective for health information it already has about you as well as any information it receives in the
                    future. You may obtain a copy of the current version of this Notice at any time in the future by contacting
                    the NWBHS Privacy Officer or asking any staff member for a copy at your next visit to NWBHS. You will be
                    asked to provide a signed acknowledgment of receipt of this Notice. Since NWBHS's intent is to make you
                    aware of the possible uses and disclosures of medical information about you and your privacy rights, the
                    delivery of your health care services will in no way be conditioned upon your signed acknowledgment of
                    this Notice. If you decline to provide a signed acknowledgment, NWBHS will continue to provide your
                    treatment and will use and disclose medicat information about you to the extent permitted by applicable
                    law.
                </p>

                <p className='w-750'><h3>USE AND DISCLOSURE OF MEDICAL INFORMATION ABOUT YOU</h3></p>

                <p className='w-750'>
                    <b>For Treatment:</b> NWBHS may use medical information about you, as needed, to provide treatment or
                    services to you. NWBHS may disclose medical information about you to, and obtain your medical
                    information from, doctors, nurses, technicians, medical students or other individuals, who are involved in
                    taking care of you. NWBHS may also disclose information about you for coordination or management of
                    your health care with a third party, such as to your other healthcare providers and your health plan.
                </p>

                <p className='w-750'>
                    NWBHS may also disclose medical information about you to, and obtain your medical information from,
                    health information exchanges in which you participate or for which you qualify for the purpose of its and
                    the other participating providers' treatment, payment and healthcare operations. Health information
                    exchanges (commonly referred to as HIEs) are electronic health information networks. Information
                    contained in HIEs may also be analyzed by the participating healthcare providers to improve their
                    respective healthcare operations.
                </p>

                <p className='w-750'>
                    NWBHS may also obtain medical information about you from (and report medical information about you
                    to) applicable industry-recognized patient data registries and repositories for treatment-related purposes
                    (e.g., to prescription registries in order to clarify your medication history and reduce potential drug
                    interactions). NWBHS may also obtain information about you from, or transmit information about you
                    through, electronic equipment and systems, such as video cameras/monitors on NWBHS premises,
                    NWBHS's computer systems and any other applicable technology.
                </p>

                <p className='w-750'>
                    <b>For Payment:</b> NWBHS may use and disclose medical information about you, as needed, to bill and collect
                    payment from you, your insurance company or a third party payer for care or treatment rendered to you.
                    For example, NWBHS may need to give your insurance company information about your treatment so that
                    it will pay NWBHS. NWBHS may also tell your health plan about treatment you are going to receive to
                    determine whether your plan Will cover the cost of services. NWBHS may also use and disclose medical
                    information about you, as needed, to obtain reimbursement from any other entity or program for services
                    provided to you by NWBHS.
                </p>
                <p className='w-750'>
                    <b>For Healthcare Operations:</b> NWBHS may use and disclose medical information about you, as needed, to
                    support the daily activities related to its healthcare services and the healthcare operations of your health
                    plan and your other healthcare providers. These activities include, but are not limited to, quality
                    assessment activities; investigations; oversight of staff performance; healthcare education; licensing;
                    fundraising; communications about a product or service, patient satisfaction surveys and focus groups, and
                    conducting or arranging for other healthcare-related activities. For example, NWBHS may disclose medical
                    information about you to behavioral health intern students observing patients at NWBHS, may call you by
                    name in a waiting room when the physician or other staff is ready to see you, and may use or disclose
                    medical information about you, as necessary, to contact you to remind you of an appointment.
                </p>

                <p className='w-750'>
                    In addition, NWBHS may permit various observers to accompany its staff as they provide care to you and
                    other clients at the facility. For example, NWBHS may permit various federal, State and local officials or
                    candidates for public office to accompany your provider in the facility or during home visits in order to
                    promote awareness regarding issues facing behavioral health providers, such as staff shortages or the need
                    for additional government funding. NWBHS may also disclose information to your health plan for your
                    health plan's coordination or management of your health care. NWBHS may share medical information
                    about you, as needed, with independent "business associates" who perform various activities (for example,
                    billing services, grant writing and survey entities) for NWBHS. NWBHS's business associates will also be
                    required to protect any medical information BH provides about you.
                </p>

                <p className='w-750'>
                    NWBHS may use limited non-medical information about you (name, address, telephone number, dates of
                    service, age and gender) to contact you in the future to inform you regarding philanthropic opportunities.
                    NWBHS may also disclose such limited information for fundraising purposes. Money raised through such
                    efforts is used to expand and improve the services and programs NWBHS provides to the various Northeast
                    Florida communities NWBHS serves. If you do not wish your information to be shared for these purposes,
                    please contact the NWBHS Privacy Office as set forth at the end of this Notice.
                </p>
                <p className='w-750'>
                    As Permitted or Required by Law: NWBHS may use or disclose medical information about you to the extent
                    permitted or required by applicable law, including but not limited to:
                </p>

                <p className='w-750'>
                    <b>For Public Health:</b> NWBHS may disclose medical information about you to a public health authority who is
                    permitted by law to collect or receive such information. Such disclosure may be necessary to do the
                    following:
                </p>

                <p className='w-750'>
                    <ul>
                        <li>Prevent or control disease, injury, or disability;
                        </li>
                        <li>Report births and deaths;
                        </li>
                        <li>Report child abuse or neglect;
                        </li>
                        <li>Report reactions to medications or problems with products;
                        </li>
                        <li>Notify a person who may have been exposed to a disease or may be at risk for contracting or spreading a
                            disease or condition; or
                        </li>
                        <li>Notify the appropriate government authority if BH believes a patient has been the victim of abuse,
                            neglect, or domestic violence.
                        </li>
                    </ul>
                </p>

                <p className='w-750'>
                    <b>Regarding Communicable Disease:</b> NWBHS may disclose medical information about you, if authorized by
                    law, to a person who might have been exposed to a communicable disease or might otherwise be at risk of
                    contracting or spreading the disease or condition.
                </p>

                <p className='w-750'>
                    <b>For Health Oversight:</b> NWBHS may disclose medical information about you to a health oversight agency for
                    activities authorized by law, such as audits, investigations and inspections. These health oversight agencies
                    may include State and federal government agencies that oversee the health care system, government
                    benefit programs, other government regulatory programs and civil rights laws. NWBHS may disclose
                    medical information about you to (and obtain medical information about you from) State and federal
                    government databases (e.g.,Fiorida's Prescription Drug Monitoring Program).
                </p>

                <p className='w-750'>
                    <b>In Legal Proceedings:</b> NWBHS may disclose medical information about you during any judicial or
                    administrative proceeding, in response to a court order or administrative tribunal (if such a disclosure is
                    expressly authorized) and, in certain conditions, in response to a subpoena, discovery request, or other
                    lawful process.
                </p>

                <p className='w-750'>
                    <b>For Law Enforcement:</b> NWBHS may disclose medical information about you for law enforcement purposes,
                    including the following:
                </p>

                <p className='w-750'>
                <ul>
                    <li>Responses to legal proceedings;
                    </li>
                    <li>Information requests for identification and location;
                    </li>
                    <li>Circumstances pertaining to victims of a crime;
                    </li>
                    <li>Deaths suspected from criminal conduct;
                    </li>
                    <li>Crimes occurring at NWBHS; or
                    </li>
                    <li>Medical emergencies believed to result from criminal conduct
                    </li>
                </ul>
                </p>

                <p className='w-750'>
                    <b>For Health, Safety and National Security: </b>NWBHS may disclose medical information about you, in
                    accordance with State and/or federal taw, if it believes that such use or disclosure is necessary to prevent
                    or lessen a serious and imminent threat to the health or safety of a person or the public. NWBHS may
                    disclose medical information about you if it is necessary for law enforcement authorities to identify or
                    apprehend an individual. NWBHS may also disclose medical information about you to authorized federal
                    officials for conducting national security and intelligence activities.
                </p>

                <p className='w-750'>
                    <b>Regarding Workers' Compensation:</b> NWBHS may disclose medical information about you to comply with
                    workers' compensation laws and other similar legally-established programs.
                </p>

                <p className='w-750'>
                    <b>To Family and Friends:</b> With your authorization, as noted below, we may disclose your protected health
                    information to family, friends and others. Additionally, if you are unable to authorize such disclosure, but
                    emergency or similar circumstances indicate that disclosure would be in your best interest, we may disclose
                    your protected information to family, friends or others to the extent necessary to help with your health
                    care coverage arrangements.
                </p>

                <p className='w-750'>
                    <b>Other Uses: </b>Uses and disclosures of your health information not covered by the Notice or otherwise
                    permitted by applicable federal or state laws will be made only with your written authorization. In addition,
                    NWBHS must have your authorization to release psychotherapy notes, to release your information for
                    third-party marketing purposes or to sell your personal information for any purpose. If you authorize
                    NWBHS to use or disclose your health information, you may revoke that permission, in writing, at any time
                    by contacting staff at NWBHS.
                </p>

                <p className='w-750'><h4>YOUR RIGHTS REGARDING MEDICAL INFORMATION ABOUT YOU</h4></p>

                <p className='w-750'>
                    You may exercise the following rights by submitting a written request to the NWBHS Privacy Officer. Please
                    be aware, however, that NWBHS might deny your request, when legally permitted to do so.
                </p>

                <p className='w-750'>
                    <b>Right to Inspect and Copy:</b> For as long as NWBHS maintains medical information about you, you may
                    inspect and obtain (for a reasonable, cost-based fee) a copy of medical information about you contained in
                    certain medical and billing records maintained by NWBHS. This right does not include inspection and
                    copying of the following records: psychotherapy notes; information compiled in reasonable anticipation of,
                </p>

                <p className='w-750'><h4>PRIVACY LAWS</h4></p>

                <p className='w-750'>
                    This Notice is provided to you as a requirement of the rules created under the Health Insurance Portability
                    and Accountability Act of 1996 (HIPAA). There are several other State and federal privacy laws that also
                    apply to medical information about you including the Freedom of Information Act, the Privacy Act and the
                    Alcohol, Drug Abuse, and Mental Health Administration Reorganization Act. To the extent not preempted
                    by HIPAA, NWBHS has taken such laws into consideration in developing its privacy policies and this Notice
                </p>

                <p className='w-750'><h4>COMPLAINTS</h4></p>

                <p className='w-750'>
                    If you believe NWBHS has failed to comply with this Notice or that NWBHS has violated these privacy rights,
                    you may file a written complaint with the NWBHS Privacy Officer or the Department of Children and
                    Families Services. NWBHS will not retaliate against you for filing a complaint. If NWBHS determines that
                    your privacy rights have been violated, you will be notified by the BH Privacy Officer (or designee).
                </p>

                <p className='w-750'>
                    You may also file a complaint with the U.S. Department of Health and Human Services Office for Civil Rights
                    at (800) 368-1019 (TDD: 800-537-7697)
                </p>

                <p className='w-750'>
                    You may also file a complaint at this link: www.hhs.gov/ocr/privacy/hipaa/complaints/
                </p>

                <p className='w-750'>
                    <b>CONTACT INFORMATION</b> You may contact the NWBHS Privacy Officer for further information about the
                    complaint process or for further explanation of this document. The NWBHS Privacy Officer (or designee)
                    may be contacted at:
                </p>

                <p className='w-750'>
                    <b>Contact Office:</b> Privacy Officer Northwest Behavioral Health Services, Inc.
                </p>

                <p className='w-750'>
                    <b>Adult Services Telephone:</b> (904) 781-7797
                </p>

                <p className='w-750'>
                    <b>Children Services Telephone:</b> (904) 781-0600
                </p>

                <p className='w-750'>
                    <b>Address:</b> P.O.Box 9373A, Jacksonville, FL 32208-0373
                </p>

                <p className='w-750'>
                    or use in, a civil, criminal, or administrative action or proceeding; and medical information about you that is
                    subject to a law that prohibits access to medical information about you.
                </p>

                <p className='w-750'>
                    <b>Right to Request Restrictions:</b> You may ask NWBHS not to use or disclose medical information about you
                    for treatment, payment, or health care operations (as described in this Notice). Your request must be
                    submitted in writing to the NWBHS Privacy Officer. In your request, you must specifically state (i) what
                    information you want restricted; (ii) whether you want to restrict NWBHS's use, disclosure, or both; (iii) to
                    whom you want the restriction to apply, for example, disclosures to your spouse; and (iv) an expiration
                    date. If NWBHS believes that the restriction is not in the best interest of either party, or NWBHS cannot
                    reasonably accommodate your request, NWBHS is not required to agree. If the restriction is agreed to by
                    NWBHS, NWBHS will not use or disclose medical information about you in violation of that restriction,
                    unless it is needed to provide emergency treatment. You may revoke a previously agreed upon restriction,
                    at any time, in writing. Contact staff to request a restriction.
                </p>

                <p className='w-750'>
                    <b>Right to Restrict Certain Health Information:</b> You may ask NWBHS not to disclose information about you
                    for payment purposes if: (i) the restriction is not otherwise prohibited by law, (ii) the disclosure is to a
                    health plan for purposes of carrying out payment or healthcare operations, (iii) the information pertains
                    solely to a service for which you paid out of pocket in full, and (iv) you made the request in writing prior to
                    the information being released. Contact staff to exercise this right.
                </p>

                <p className='w-750'>
                    <b>Right to Request Confidential Communications: </b>You may request that NWBHS communicate with you
                    using alternative means (e.g., e-mail) or at an alternative location (e.g., post office box). NWBHS will not ask
                    you the reason for your request, and will accommodate reasonabie requests, when possible. If you request
                    communication via unencrypted e-mail, please be aware that receiving or forwarding unencrypted e-mail
                    could make that communication vulnerable to third party interference.
                </p>

                <p className='w-750'>
                    <b>Right to Request Amendment:</b> If you believe that the information NWBHS maintains about you is incorrect
                    or incomplete, you may request an amendment to such information. While NWBHS will accept requests for
                    amendment, NWBHS is not legally required to agree to an amendment.
                </p>

                <p className='w-750'>
                    <b>Right to an Accounting of Certain Disclosures:</b> You may request that NWBHS provide you with an
                    accounting of certain disclosures it has made of medical information about you. This right applies to
                    disclosures made for purposes other than treatment, payment or health care operations (as described in
                    this Notice). To be accountable, the disclosure must have been made after July 1, 2012 and no more than 6
                    years from the date of your request. This right excludes disclosures made to you, to family members or
                    friends involved in your care or for notifications required by law (including disclosures for law enforcement,
                    national security or intelligence purposes). The right to receive this information is subject to additional
                    exceptions, restrictions, and limitations as described earlier in this Notice.
                </p>

                <p className='w-750'>
                    <b>Right to Obtain a Copy of this Notice: </b>You may obtain a paper copy of this Notice (or the version currently
                    in effect) from NWBHS staff at intake and on annual basis.
                </p>

                <p className='w-750'><h3>Northwest Behavioral Health Services, Inc</h3></p>
                <p className='w-750'><h3>Annual Notice of Privacy Practices</h3></p>
                <p className='w-750'><h3>Receipt Confirmation</h3></p>

                <p className='w-750'>
                    I hereby acknowledge that I have received from Northwest Behavioral Health Services, Inc. a
                    copy of its Notice of Privacy Practices. I understand that the Notice of Privacy Practices sets
                    forth my rights relating to the use and disclosure of my personal health infomaation and explains
                    how Northwest Behavioral Health Services, Inc. may use and/or disclose my personal health
                    information both with and vhthout my authorization. I further understand that I may contact the
                    Privacy Offlcer if I have any questions regarding the contents of this Notice of Privacy Practices
                    or to file a complaint about the privacy practices of Northwest Behavioral Health Services, Inc.
                </p>


            </div>
        </form>

    )
}  

